import {Locale} from '../RootProvider/LocaleContext';

// must match https://www.w3schools.com/tags/ref_language_codes.asp
export enum HrefLanguage {
  nl = 'nl',
  uk = 'en',
}

// this is used to pass the correct Locale to the hrefLang
const getHrefLanguageFromLocale = (locale: Locale): HrefLanguage => {
  switch (locale) {
    case Locale.nl:
      return HrefLanguage.nl;
    case Locale.uk:
    default:
      return HrefLanguage.uk;
  }
};

export default getHrefLanguageFromLocale;
